import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import Select from "react-select";
import Pagination from "react-js-pagination";

import TextField from '@material-ui/core/TextField';
import CustomAutocomplete from "../CustomAutocomplete";
import { createFilterOptions } from '@material-ui/lab/Autocomplete';

import { AgGridReact } from "ag-grid-react";


import PersonFilter from './group_type';

class Groups extends Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();

        var has_local_data = localStorage.getItem("encdata") ? 1 : 0;
        var localdata = has_local_data
            ? this.decrypt(localStorage.getItem("encdata"), 0)
            : "";

        this.state = {
            userAuthKey: has_local_data ? localdata.user_key : "",
            apiUrl: this.decryptconfigdata("apiUrl"),
            userId: has_local_data ? localdata.user_id : "",
            user_Name: has_local_data ? localdata.user_name : "",

            groups: [],
            group_types: [{ value: "all", label: "All" }],
            group_members: [],
            group_pods: [],
            defaultList: [],
            selected_primary: [],
            selected_lister: [],

            hr_permission: 'no',
            manager_permission: 'no',

            waiting: '',
            errors: {},
            formData: {},
            success_message: '',
            paginationPageSize: 10,
            desctextlen: 500,
            group_type: "all",
            currentPage: 0,
            totalPages: 0,
            totalRows: 0,
            search: '',
            columns: [{
                headerName: "Group Name",
                field: "name",
                sortable: true,
                suppressMenu: true,
                //tooltipField: 'name', 
                filter: 'agTextColumnFilter',
                //floatingFilter: true,
                cellRenderer: this.LinksGenerator,
                width: 200,
            },
            {
                headerName: "Group Email",
                field: "email",
                sortable: true,
                suppressMenu: true,
                //tooltipField: 'email', 
                filter: 'agTextColumnFilter',
                //floatingFilter: true,
                width: 200,
            },
            {
                headerName: "Type",
                field: "type_name",
                sortable: true,
                suppressMenu: true,
                //tooltipField: 'type_name', 
                filter: 'agTextColumnFilter',
                //floatingFilter: true,
                width: 150,
            },
            {
                headerName: "Description",
                field: "description",
                sortable: true,
                suppressMenu: true,
                tooltipField: 'description',
                filter: 'agTextColumnFilter',
                // cellStyle: { "white-space": "normal" },
                // autoHeight: true,
                //floatingFilter: true,
                width: 400,
            }],

        };
        this.onPageSizeChanged = this.onPageSizeChanged.bind(this);


    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
        var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv,
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    rawjsonparse(findresponse, flg) {
        return findresponse;
    }


    LinksGenerator(params) {
        let cellvalue = params.value;
        let links = '';
        let data = '';
        if (typeof cellvalue !== 'undefined' && cellvalue.length > 0) {
            data = params.data;
            links = <a href={"/viewGroups/" + data.email}>{cellvalue}</a>
        }
        return links;
    }


    onPageSizeChanged = (event) => {
        this.setState({ paginationPageSize: event.target.value });
        this.gridApi.paginationSetPageSize(Number(event.target.value));
        // Update pagination info after page size changes
        this.updatePaginationInfo();
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        
        // Update pagination info when grid is ready
        this.updatePaginationInfo();
    };

    updatePaginationInfo = () => {
        if (this.gridApi) {
            const currentPage = this.gridApi.paginationGetCurrentPage();
            const totalRows = this.gridApi.getDisplayedRowCount();
            const pageSize = this.gridApi.paginationGetPageSize();
            const totalPages = Math.ceil(totalRows / pageSize);
            
            this.setState({
                currentPage: currentPage,
                totalRows: totalRows,
                totalPages: totalPages
            });
        }
    };

    onPaginationChanged = () => {
        // This will be called whenever pagination changes
        this.updatePaginationInfo();
    };

    searchGrid = (event) => {
        const { name, value } = event.target;
        this.setState({
            search: value
        });
        this.gridApi.setQuickFilter(value);
    };

    showAddGroup() {
        this.setState({
            waiting: '',
            errors: {},
            success_message: '',
            selected_pod_list: [],
            selected_product_list: [],
            formData: { 'group_type': "1", 'name': '', 'email': '', 'description': '', 'listener_members': [], 'primary_members': [], 'members': [], 'pod_includes': [], 'pod_includes': [] }
        });
    }

    showTextLimit(e) {
        var maxLength = 500;
        var desctextlen = maxLength - e.target.value.length;
        this.setState({ desctextlen });
    }

    onChangeFrom(type, e) {

        console.log(e);
        console.log("type", type);

        var formData = this.state.formData;

        var errors = this.state.errors;

        if (type == 'primary_members') {

            let primary_members = [];

            e.forEach((element) => {
                primary_members.push(element.id);
            });

            formData['selected_primary_members'] = e;

            formData[type] = primary_members;

        } else if (type == 'listener_members') {

            let listener_members = [];

            e.forEach((element) => {
                listener_members.push(element.id);
            });

            formData[type] = listener_members;

            formData['selected_listener_members'] = e;

        } else if (type == 'members') {

            let members = [];

            e.forEach((element) => {
                members.push(element.id);
            });

            formData['selected_members'] = e;

            formData[type] = members;

        } else if (type == 'pod_includes') {

            let pod_includes = [];

            e.forEach((element) => {
                pod_includes.push(element.id);
            });

            formData['selected_pod_includes'] = e;

            formData[type] = pod_includes;

        } else {
            formData[type] = e.target.value;
            if (type == "group_type") {
                errors = {};
                this.setState({ errors });
            }
        }

        console.log(formData);

        errors[type] = '';

        this.setState({
            formData: formData,
            errors: errors,
        });

    }

    handleValidation() {
        let formData = this.state.formData;
        let errors = {};
        let formIsValid = true;

        var regName = /^[a-z\d\-_\s]+$/i;

        var regEmail = /@muvi.com\s*$/;

        var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

        if (!formData["name"] || !formData["name"].trim()) {
            formIsValid = false;
            errors["name"] = "Please enter group name";

        } else if (!regName.test(formData["name"])) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";

        } else if (Number(formData["name"])) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";

        } else if (formData["name"] < 1) {
            formIsValid = false;
            errors["name"] = "Please enter a valid group name";

        } else if (formData["name"].length > 150) {
            formIsValid = false;
            errors["name"] = "Group Name must not be greater than 150 character length";
        }


        if (!formData["email"] || !formData["email"].trim()) {
            formIsValid = false;
            errors["email"] = "Please enter email";

        } else if (!pattern.test(formData["email"])) {
            formIsValid = false;
            errors["email"] = "Please provide correct Email.";

        } else if (formData["email"] && !regEmail.test(formData["email"])) {
            formIsValid = false;
            errors["email"] = "The domain name should be muvi.com";
        }

        if (formData["group_type"] == 1 || formData["group_type"] == 2 || formData["group_type"] == 4) {
            if (!formData["primary_members"] || formData["primary_members"] == "") {
                formIsValid = false;
                errors["primary_members"] = "Please choose a primary member";
            }

            if (!formData["listener_members"] || formData["listener_members"] == "") {
                formIsValid = false;
                errors["listener_members"] = "Please choose a listener member";
            }
        } else if (formData["group_type"] == 5) {
            if (!formData["members"] || formData["members"] == "") {
                formIsValid = false;
                errors["members"] = "Please choose a member";
            }

        } else if (formData["group_type"] == 3) {
            if (!formData["pod_includes"] || formData["pod_includes"] == "") {
                formIsValid = false;
                errors["pod_includes"] = "Please choose a pod";
            }
        }

        this.setState({ errors: errors });

        return formIsValid;
    }


    AddGroup() {
        this.setState({ waiting: 'loading' });

        let is_valid = this.handleValidation();

        if (!is_valid) {
            this.setState({ waiting: '' });
            return false;
        }

        let errors = {};

        let formData = this.state.formData;

        let api_url = this.state.apiUrl + '/HrmanagementRest/CreateGroup/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey;

        fetch(api_url, {
            method: 'POST',
            dataType: "json",
            body: JSON.stringify(formData),
        }).then((Response) => Response.json())
            .then((findresponse) => {

                if (findresponse.code == 200) {

                    window.$("#addGroup").modal('hide');

                    this.GetAllGroupList();
                    window.$("#quiz_Pass").modal('show');
                    if (this.timer) {
                        window.clearTimeout(this.timer);
                    }
                    this.timer = window.setTimeout(function () {
                        window.$("#quiz_Pass").modal('hide');
                    }, 1500);

                    this.setState({ waiting: '', formData: { 'group_type': 1, 'name': '', 'email': '', 'description': '', 'listener_members': [], 'primary_members': [], 'members': [], 'pod_includes': [], 'pod_includes': [] } });

                } else if (findresponse.code == 401) {

                    var status = findresponse.status;

                    errors[status] = findresponse.msg;

                    this.setState({ waiting: '' });
                }

                this.setState({ errors: errors });

            }).catch(function (error) {

                errors['form'] = error;

                console.log(error);
            });
    }

    showAdvFilter(divId) {
		var element = document.getElementById(divId);
		element.classList.toggle("show");
		if (divId == "adv_filter") this.setState({ showFilter: !this.state.showFilter });
	}

    getFilter() {
        return (
            <div id="adv_filter" class="adv_filter filter-wrap">
                <div class="containerfull">
                    <div class="row">
                        <div class="col-md-3 col-lg-3 mb10">
                            <div class="input-box adv-filter-dd">
                                <label class="input-label">Type</label>
                                <Select
                                    value={
                                        this.state.group_type && this.state.group_types.length > 0
											? this.state.group_types.filter(
												(na) => na.value === this.state.group_type
											)
											: ""
                                    }
                                    className="single-select"
                                    classNamePrefix="single-select"
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={(e) => this.filterGroup(e)}
                                    options={
                                        this.state.group_types.map((item) => {
                                            return { label: item.label, value: item.value };
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    filterGroup(e) {
        var group_type = e.value;
        this.setState({ group_type }, function () {
            this.GetAllGroupList();
        });
    }

    GetAllGroupList() {
        console.log(396, this.state.group_type)
        fetch(this.state.apiUrl + '/HrmanagementRest/GetAllGroups' + '/group_type/' + this.state.group_type + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: "POST",
            dataType: "json",
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {

                findresponse = this.decrypt(findresponse, 1);

                console.log(findresponse);

                let group_types = [{ value: "all", label: "All" }];

                if (findresponse.group_types && findresponse.group_types.length > 0) {
                    findresponse.group_types.forEach((item) => {
                        group_types.push({ value: item.group_type, label: item.type_name });
                    });
                }

                this.setState({
                    groups: findresponse.groups,
                    group_types: group_types,
                    hr_permission: findresponse.hr_permission,
                    manager_permission: findresponse.manager_permission,
                    group_members: findresponse.group_members,
                    group_pods: findresponse.group_pods,
                }, () => {
                    // Update pagination info after state is set
                    this.updatePaginationInfo();
                });
            });
    }

    componentDidMount() {

        document.title = "Intranet | Groups";

        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }

        this.GetAllGroupList();

    }
    
    resetHandler = () => {
        this.setState({ 
            group_type: "all",
            search: '',
        }, () => {
            this.gridApi.paginationGoToPage(0);
            this.gridApi.setQuickFilter('');
            this.GetAllGroupList();
        });
    };
    
    resetMembers() {
        var formData = {};
        this.setState({ formData });
    }

    render() {

        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }

        const filterOptions = createFilterOptions({
            matchFrom: 'start',
            stringify: option => option.name,
        });

        return (
            <div>
                <Header brecum_name="Groups" brecum_page="Groups" />
                <div class="right_col">
                    <div class="customer-wrap">
						<div class="page-top">
							<div class="containerfull">
								<div class="row">
									<div class="col-md-4">
										<div class="row">
											<div class="col-md-6">
												<div class="mt-10">
													<div class="d-flex align-items-center">
														<h2>Groups</h2>
														<span class="badge-blue">{this.state.totalRows || 0}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-1"></div>
									<div class="col-md-7">
										<div class="d-flex">
                                            <div className="searchTicket emp_dept">
                                                <input
                                                    type="text"
                                                    class="form-control input-f"
                                                    name="search"
                                                    id="search"
                                                    placeholder="Search by keyword"
                                                    value={this.state.search}
                                                    onChange={this.searchGrid}
                                                />
												<button type="submit">
													<svg
														width="18"
														height="19"
														viewBox="0 0 18 19"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M8.25 14.75C11.5637 14.75 14.25 12.0637 14.25 8.75C14.25 5.43629 11.5637 2.75 8.25 2.75C4.93629 2.75 2.25 5.43629 2.25 8.75C2.25 12.0637 4.93629 14.75 8.25 14.75Z"
															stroke="white"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
														<path
															d="M15.75 16.25L12.4875 12.9875"
															stroke="white"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</button>
                                            </div>
											<div
												id="toggle-btnf"
												class={"toogle-btn" + (this.state.showFilter ? " collapse-state" : "")}
												onClick={() => this.showAdvFilter("adv_filter")}
											>
												<svg
													width="17"
													height="44"
													viewBox="0 0 17 44"
													fill="none"
													xmlns="http://www.w3.org/2000/svg"
												>
													<g clip-path="url(#clip0_1134_22629)">
														<path
															d="M1.66992 18H15.6699"
															stroke="#5C5F62"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
														<path
															d="M4.16992 22H13.1699"
															stroke="#5C5F62"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
														<path
															d="M7.16992 26H10.1699"
															stroke="#5C5F62"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</g>
													<defs>
														<clipPath id="clip0_1134_22629">
															<rect
																width="16"
																height="44"
																fill="white"
																transform="translate(0.669922)"
															></rect>
														</clipPath>
													</defs>
												</svg>
											</div>
											<div class="toogle-btn" onClick={this.resetHandler} style={{ height: "40px" }}>
												<span>
													<svg
														width="16"
														height="16"
														viewBox="0 0 16 16"
														fill="none"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M0.666748 2.66666V6.66666H4.66675"
															stroke="#202223"
															stroke-opacity="0.5"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
														<path
															d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
															stroke="#202223"
															stroke-opacity="0.5"
															stroke-width="1.33"
															stroke-linecap="round"
															stroke-linejoin="round"
														></path>
													</svg>
												</span>
											</div>
											{this.state.hr_permission == "yes" ? (
                                                <div className='left-section pull-right'>
                                                    <button 
                                                        className="btn btn-sky"
                                                        data-toggle="modal"
                                                        data-target="#addGroup"
                                                        onClick={() => this.showAddGroup()}
                                                        >
                                                        Add Group
                                                    </button>
                                                </div>
											) : (
												""
											)}
											<div class="clear"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{this.getFilter()}
                        <div class="body-content">
                            <div class="employee-list table-wrap">
                                <div
                                    className="ag-theme-material"
                                    style={{
                                        minHeight: '530px',
                                        height: '70vh',
                                        width: '100%'
                                    }}
                                >
                                    <AgGridReact
                                        rowData={this.state.groups}
                                        columnDefs={this.state.columns}
                                        pagination={true}
                                        paginationPageSize={this.state.paginationPageSize}
                                        onGridReady={this.onGridReady}
                                        onPaginationChanged={this.onPaginationChanged}
                                        onRowDataChanged={this.updatePaginationInfo}
                                        onFilterChanged={this.updatePaginationInfo}
                                        enableCellTextSelection={true}
                                        ensureDomOrder={true}
                                        suppressPaginationPanel={true}
                                    />
                                </div>
                                {
                                    this.gridApi && (
                                        <div
                                            class="d-flex mu-pagination justify-content-between align-items-center"
                                            aria-label="Page navigation example"
                                        >
                                            <div class="txt-dark">
                                                Showing {this.state.currentPage + 1}~{this.state.totalPages} of {this.state.totalRows}
                                            </div>
                                            <div class="mu-pagination">
                                                <Pagination
                                                    activePage={this.state.currentPage + 1}
                                                    itemsCountPerPage={this.state.paginationPageSize}
                                                    totalItemsCount={this.state.totalRows}
                                                    pageRangeDisplayed={5}
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    onChange={(pageNumber) => {
                                                        this.gridApi.paginationGoToPage(pageNumber - 1);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="add_popup">
                    <div class="modal fade" id="addGroup" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog">
                        <div class="modal-dialog modal-dialog-centered">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <button type="button" class="close" data-dismiss="modal" onClick={() => this.resetMembers()}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M15 5L5 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            <path d="M5 5L15 15" stroke="#333333" stroke-opacity="0.5" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                    </button>
                                    <h4 class="modal-title">Add Group</h4>
                                </div>
                                <div class="modal-body">
                                    <div className="row mt15">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="tag-newlabel" for="group_type">Type<span class="star">*</span></label>
                                                <select class="form-control" id="group_type" name="group_type" onChange={(e) => this.onChangeFrom('group_type', e)}>
                                                    {this.state.group_types.filter((e) => e.value != 'all').map((dynamicData, key) =>
                                                        <option value={dynamicData.value} selected={dynamicData.value == this.state.formData['group_type'] ? "selected" : ""} >{dynamicData.label}</option>
                                                    )}
                                                </select>
                                                <span className="error">{this.state.errors["group_type"]}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="tag-newlabel" for="name">Name<span class="star">*</span></label>
                                                <input type="text" class="form-control" name="name" id="name" autoComplete="off" placeholder='Name' onChange={(e) => this.onChangeFrom('name', e)} value={this.state.formData['name']} />
                                                <span className="error">{this.state.errors["name"]}</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                                <label className="tag-newlabel" for="email">Email<span class="star">*</span></label>
                                                <input type="text" class="form-control" name="email" id="email" placeholder='Email' autoComplete="off" onChange={(e) => this.onChangeFrom('email', e)} value={this.state.formData['email']} />
                                                <span className="error">{this.state.errors["email"]}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label className="tag-newlabel" for="description">Description</label>
                                                <textarea class="form-control" maxlength="500" name="description" id="description" autoComplete="off" placeholder='Description' onKeyUp={(e) => this.showTextLimit(e)} onChange={(e) => this.onChangeFrom('description', e)} rows="5" value={this.state.formData['description']} style={{ resize: 'none' }}></textarea>
                                                <span style={{ "color": "gray" }}>{this.state.desctextlen} / 500 </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-6">
                                            {(this.state.formData['group_type'] == 1) || (this.state.formData['group_type'] == 2) || (this.state.formData['group_type'] == 4) ?
                                                <div className="form-group">
                                                    <label className="tag-newlabel" for="primary_members">Primary<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeFrom('primary_members', value)
                                                        }
                                                        getOptionDisabled={(option) => !!this.state.formData['listener_members'].find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Primary Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["primary_members"]}</span>
                                                </div>
                                                : ""}
                                        </div>
                                        <div className="col-md-6">
                                            {(this.state.formData['group_type'] == 1) || (this.state.formData['group_type'] == 2) || (this.state.formData['group_type'] == 4) ?
                                                <div className="form-group">
                                                    <label className="tag-newlabel" for="listener_members">Listener<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeFrom('listener_members', value)
                                                        }
                                                        getOptionDisabled={(option) => !!this.state.formData['primary_members'].find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Listener Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["listener_members"]}</span>
                                                </div>
                                                : ""}
                                        </div>
                                        {this.state.formData['group_type'] == 5 ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="tag-newlabel" for="members">Members<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_members}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeFrom('members', value)
                                                        }
                                                        // onChange={(event , value) => this.handlePrimaryChange(value)}
                                                        // getOptionDisabled={(option) => !! this.state.defaultList.find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="Members"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["members"]}</span>
                                                </div>
                                            </div>
                                            : ""}

                                        {this.state.formData['group_type'] == 3 ?
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label className="tag-newlabel" for="pod_includes">Includes<span class="star">*</span></label>
                                                    <CustomAutocomplete
                                                        multiple
                                                        options={this.state.group_pods}
                                                        limitTags={5}
                                                        getOptionLabel={(option) => option.name}
                                                        onChange={(event, value) =>
                                                            this.onChangeFrom('pod_includes', value)
                                                        }
                                                        // onChange={(event , value) => this.handlePrimaryChange(value)}
                                                        // getOptionDisabled={(option) => !! this.state.defaultList.find(element => element === option.id)}
                                                        filterOptions={filterOptions}
                                                        filterSelectedOptions
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"

                                                                placeholder="POD"
                                                            />
                                                        )}
                                                    />
                                                    <span className="error">{this.state.errors["pod_includes"]}</span>
                                                </div>
                                            </div>
                                            : ""}
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <span style={{ float: 'left', color: 'red' }}>{this.state.errors["form"]}</span>
                                            {this.state.success_message ? <span style={{ float: 'left', color: 'green' }}>{this.state.success_message}</span> : ''}
                                            <div class="all-boxbtn">
                                                <button type="button" class="dissmiss-btn" data-dismiss="modal" onClick={() => this.resetMembers()}>Dismiss</button>
                                                {this.state.waiting ?
                                                    <button type="submit" className="btn btn-sky disabled" ><div><i className="fa fa-spinner fa-spin"></i><span> Wait</span></div></button>
                                                    :
                                                    <button type="submit" className="adds-btn" onClick={() => this.AddGroup()} >Add</button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="editLink_popup">
                    <div className="modal fade" id="quiz_Pass" tabIndex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 className="modal-title text-center">Success</h2>
                                </div>
                                <div className="modal-body">
                                    <div className="icon_txt">
                                        <i className="fal fa-check-circle"></i>
                                        <span>Group has been created successfully</span>
                                    </div>
                                    <p className="text-center mt20">
                                        <button className="btn btn block" data-dismiss="modal">Close</button>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Groups;



// WEBPACK FOOTER //
// ./src/components/hrAdmin/groups.js